import PropTypes from "prop-types";
import { FilterSelect } from "@/components/common/FilterSelect";
import {
  CAMPAIGN_CHANNEL_OPTIONS,
  CAMPAIGN_STATUS_OPTIONS,
} from "./campaignDashboardUtils";

/**
 * Campaign filters. When `compact` is true, renders pill FilterSelects
 * that match the Outreach design prototype toolbar.
 */
export function CampaignFilters({
  status,
  channel,
  onStatusChange,
  onChannelChange,
  onClear,
  hasActiveFilters,
  compact = false,
}) {
  if (compact) {
    return (
      <fieldset
        aria-label="Campaign filters"
        data-testid="campaign-filters"
        className="m-0 border-0 p-0 flex gap-2.5 flex-wrap items-center min-w-0"
      >
        <FilterSelect
          value={status}
          onChange={onStatusChange}
          options={CAMPAIGN_STATUS_OPTIONS}
          aria-label="Filter by status"
        />
        <FilterSelect
          value={channel}
          onChange={onChannelChange}
          options={CAMPAIGN_CHANNEL_OPTIONS}
          aria-label="Filter by channel"
        />
        {hasActiveFilters && (
          <button type="button" className="btn sm" onClick={onClear} data-testid="clear-campaign-filters">
            Clear filters
          </button>
        )}
      </fieldset>
    );
  }

  // Non-compact fallback (unused by dashboard page, kept for reuse)
  return (
    <fieldset aria-label="Campaign filters" data-testid="campaign-filters">
      <FilterSelect
        value={status}
        onChange={onStatusChange}
        options={CAMPAIGN_STATUS_OPTIONS}
        aria-label="Filter by status"
      />
      <FilterSelect
        value={channel}
        onChange={onChannelChange}
        options={CAMPAIGN_CHANNEL_OPTIONS}
        aria-label="Filter by channel"
      />
      {hasActiveFilters && (
        <button type="button" onClick={onClear} data-testid="clear-campaign-filters">Clear filters</button>
      )}
    </fieldset>
  );
}

CampaignFilters.propTypes = {
  status: PropTypes.string.isRequired,
  channel: PropTypes.string.isRequired,
  onStatusChange: PropTypes.func.isRequired,
  onChannelChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  hasActiveFilters: PropTypes.bool.isRequired,
  compact: PropTypes.bool,
};
